import { useCallback, useState } from 'react';
import { ConversationListItem } from '../../../../../../../../store/dashboard/askAica/types';
import { ASK_AICA_TEAM_CONVERSATIONS_COLLAPSED_LIMIT } from '../../../../../../../../store/dashboard/askAica/constants';

export const useCollapsibleTeamList = (items: ConversationListItem[], enabled: boolean) => {
    const [expanded, setExpanded] = useState(false);
    const toggle = useCallback(() => setExpanded((prev) => !prev), []);

    const showToggle = enabled && items.length > ASK_AICA_TEAM_CONVERSATIONS_COLLAPSED_LIMIT;
    const visibleItems = showToggle && !expanded ? items.slice(0, ASK_AICA_TEAM_CONVERSATIONS_COLLAPSED_LIMIT) : items;

    return { visibleItems, showToggle, expanded, toggle };
};
